// extracted by mini-css-extract-plugin
module.exports = {"contact_column":"contacts_contact_column__Cu7cX"};